import React from 'react';

export const EmailDropdown = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 11L21 13L24 11" stroke="black" strokeWidth="1.5" />
    <rect
      height="10.8889"
      rx="1.55556"
      stroke="black"
      strokeWidth="1.5"
      width="14"
      x="1"
      y="6.55556"
    />
    <path
      d="M1 9.08333L7.06667 13.6333C7.61975 14.0481 8.38025 14.0481 8.93333 13.6333L15 9.08333"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
